import Vue from "vue";
import VueRouter from "vue-router";
import AuthGuard from "./utils/auth.guard";
import { getCurrentUser } from "./utils/index";
import { adminRoot } from "./constants/config";
import { UserRole } from "./utils/auth.roles";

Vue.use(VueRouter);

let defaultRedirect = '';

if (getCurrentUser()) {
    const authRoleId = getCurrentUser().role;
    // defaultRedirect = authRoleId == 1 ? `${adminRoot}/users` : `${adminRoot}/quotes`;
    defaultRedirect = authRoleId == 1 ? `${adminRoot}/users` : `${adminRoot}/users`;
}

const routes = [{
    path: "/",
    component: () =>
        import("./views/app/piaf"),
    redirect: defaultRedirect,
    meta: { loginRequired: true }
},
{
    path: adminRoot,
    component: () =>
        import("./views/app"),
    redirect: defaultRedirect,
    meta: { loginRequired: true },
    children: [
        /*{
            path: "home",
            component: () => import("./views/app/piaf")
        },*/
        {
            path: "users",
            component: () =>
                import("./views/app/users"),
            redirect: `${adminRoot}/users`,
            meta: { roles: [UserRole.SUPERADMIN, UserRole.ADMIN, UserRole.ADMINALIADO] },
            children: [{
                path: "/",
                component: () =>
                    import("./views/app/users/list")
            },
            {
                path: ":id/edit",
                component: () =>
                    import("./views/app/users/edit")
            },
            {
                path: "send-sms",
                component: () =>
                    import("./views/app/users/send-sms")
            },
            {
                path: "send-push",
                component: () =>
                    import("./views/app/users/send-push")
            }
            ]
        },
        {
            path: "aliado",
            component: () =>
                import("./views/app/aliado"),
            redirect: `${adminRoot}/aliado/promotions`,
            meta: { roles: [UserRole.SUPERADMIN, UserRole.ADMIN, UserRole.ADMINALIADO] },
            children: [{
                path: 'promotions',
                component: () =>
                    import("./views/app/aliado/promotions/list")
            },
            {
                path: "promotions/store",
                component: () =>
                    import("./views/app/aliado/promotions/store")
            },
            {
                path: "promotions/:id/edit",
                name: 'promotionedit',
                component: () =>
                    import("./views/app/aliado/promotions/edit")
            },
            {
                path: 'cartilla',
                component: () =>
                    import("./views/app/aliado/cartilla/list")
            },
            {
                path: "cartilla/:id/edit",
                component: () =>
                    import("./views/app/aliado/cartilla/edit")
            },
            {
                path: 'interchange',
                component: () =>
                    import("./views/app/aliado/interchange/list")
            },
            {
                path: "interchange/:id/edit",
                component: () =>
                    import("./views/app/aliado/interchange/edit")
            }
            ]
        },
        {
            path: "quotes",
            component: () =>
                import("./views/app/quotes")
        },
        {
            path: "banners",
            component: () =>
                import("./views/app/banners"),
            redirect: `${adminRoot}/banners`,
            meta: { roles: [UserRole.SUPERADMIN, UserRole.ADMIN] },
            children: [{
                path: "/",
                component: () =>
                    import("./views/app/banners/list")
            },
            {
                path: "store",
                component: () =>
                    import("./views/app/banners/store")
            },
            {
                path: ":id/edit",
                name: 'banneredit',
                component: () =>
                    import("./views/app/banners/edit")
            }
            ]
        },
        {
            path: "export",
            component: () =>
                import("./views/app/export"),
            meta: { roles: [UserRole.SUPERADMIN, UserRole.ADMIN] }
        },
        {
            path: "events",
            component: () =>
                import("./views/app/events"),
            redirect: `${adminRoot}/events`,
            meta: { roles: [UserRole.SUPERADMIN, UserRole.ADMIN] },
            children: [{
                path: "/",
                component: () =>
                    import("./views/app/events/list")
            },
            {
                path: "store",
                component: () =>
                    import("./views/app/events/store")
            },
            {
                path: ":id/edit",
                name: 'eventedit',
                component: () =>
                    import("./views/app/events/edit")
            },
            {
                path: ":id/registered-users",
                component: () =>
                    import("./views/app/events/inscriptions")
            },
            {
                path: ":id/chat",
                component: () =>
                    import("./views/app/events/chat")
            }
            ]
        },
        {
            path: "capacitate",
            component: () =>
                import("./views/app/capacitate"),
            redirect: `${adminRoot}/capacitate`,
            meta: { roles: [UserRole.SUPERADMIN, UserRole.ADMIN] },
            children: [{
                path: "/",
                name: "capacitate",
                component: () =>
                    import("./views/app/capacitate/list")
            },
            {
                path: "banners/store",
                component: () =>
                    import("./views/app/capacitate/banners/store")
            },
            {
                path: "banners/:id/edit",
                name: 'bannercapedit',
                component: () =>
                    import("./views/app/capacitate/banners/edit")
            },
            {
                path: "courses/store",
                component: () =>
                    import("./views/app/capacitate/courses/store")
            }, {
                path: "courses/:id/edit",
                name: 'course_edit',
                component: () =>
                    import("./views/app/capacitate/courses/edit")
            }, {
                path: "courses/classes/store",
                component: () =>
                    import("./views/app/capacitate/courses/classes/store")
            }, {
                path: "courses/classes/:id/edit",
                component: () =>
                    import("./views/app/capacitate/courses/classes/edit")
            }, {
                path: "subcategories/store",
                component: () =>
                    import("./views/app/capacitate/subcategories/store")
            }, {
                path: "subcategories/:id/edit",
                name: "subcategoria_edit",
                component: () =>
                    import("./views/app/capacitate/subcategories/edit")
            }
            ]
        },
        /*{
            path: "courses",
            component: () =>
                import ("./views/app/courses"),
            redirect: `${adminRoot}/courses`,
            meta: { roles: [UserRole.SUPERADMIN,UserRole.ADMIN] },
            children: [{
                    path: "/",
                    component: () =>
                        import ("./views/app/courses/list")
                },
                {
                    path: "store",
                    component: () =>
                        import ("./views/app/courses/store")
                },
                {
                    path: ":id/edit",
                    name: 'courseedit',
                    component: () =>
                        import ("./views/app/courses/edit")
                },
                {
                    path: ":id/classes",
                    component: () =>
                        import ("./views/app/courses/classes")
                },
                {
                    path: ":id/users",
                    component: () =>
                        import ("./views/app/courses/users")
                }
            ]
        },*/
        {
            path: "classes",
            component: () =>
                import("./views/app/classes"),
            redirect: `${adminRoot}/classes`,
            meta: { roles: [UserRole.SUPERADMIN, UserRole.ADMIN] },
            children: [{
                path: "store",
                component: () =>
                    import("./views/app/classes/store")
            },
            {
                path: ":id/edit",
                name: 'classedit',
                component: () =>
                    import("./views/app/classes/edit")
            },
            {
                path: ":id/users",
                component: () =>
                    import("./views/app/classes/users")
            }
            ]
        },
        /*{
            path: "mailing",
            component: () =>
                import ("./views/app/mailing"),
            redirect: `${adminRoot}/mailing/monthly-course`,
            meta: { roles: [UserRole.ADMIN] },
            children: [{
                    path: 'monthly-course',
                    component: () =>
                        import ("./views/app/mailing/monthly_course/index")
                },
                {
                    path: 'monthly-course/store',
                    component: () =>
                        import ("./views/app/mailing/monthly_course/store")
                },
                {
                    path: 'achievements',
                    component: () =>
                        import ("./views/app/mailing/achievements")
                },
                {
                    path: 'performance',
                    component: () =>
                        import ("./views/app/mailing/performance")
                },
                {
                    path: ':id/stats',
                    component: () =>
                        import ("./views/app/mailing/stats")
                }
            ]
        },*/
        {
            path: "blogs",
            component: () =>
                import("./views/app/blogs"),
            redirect: `${adminRoot}/blogs`,
            meta: { roles: [UserRole.SUPERADMIN, UserRole.ADMIN] },
            children: [{
                path: "/",
                component: () =>
                    import("./views/app/blogs/list")
            },
            {
                path: "store",
                component: () =>
                    import("./views/app/blogs/store")
            },
            {
                path: ":id/edit",
                name: 'blogedit',
                component: () =>
                    import("./views/app/blogs/edit")
            }
            ]
        },
        {
            path: "slides",
            component: () =>
                import("./views/app/slides"),
            redirect: `${adminRoot}/slides`,
            meta: { roles: [UserRole.SUPERADMIN, UserRole.ADMIN] },
            children: [{
                path: "/",
                component: () =>
                    import("./views/app/slides/list")
            },
            {
                path: "store",
                component: () =>
                    import("./views/app/slides/store")
            },
            {
                path: ":id/edit",
                name: 'slideedit',
                component: () =>
                    import("./views/app/slides/edit")
            },
            {
                path: ":id/questions",
                component: () =>
                    import("./views/app/slides/questions")
            }
            ]
        },
        {
            path: "pollamundial",
            component: () =>
                import("./views/app/pollamundial"),
            redirect: `${adminRoot}/pollamundial`,
            meta: { roles: [UserRole.SUPERADMIN, UserRole.ADMIN] },
            children: [{
                path: "/",
                name: "pollamundial",
                component: () =>
                    import("./views/app/pollamundial/list")
            },
            {
                path: "nuevo",
                component: () =>
                    import("./views/app/pollamundial/nuevo")
            },
            {
                path: ":id/edit",
                name: 'slideedit',
                component: () =>
                    import("./views/app/pollamundial/edit")
            }
            ]
        },
        {
            path: "auditoria",
            component: () =>
                import("./views/app/auditoria"),
            redirect: `${adminRoot}/auditoria`,
            meta: { roles: [UserRole.SUPERADMIN] },
            children: [{
                path: "admin",
                //name: "cxp",
                component: () =>
                    import("./views/app/auditoria/admin")
            },
            {
                path: "moderador",
                component: () =>
                    import("./views/app/auditoria/moderador")
            }
            ]
        },

        {
            path: "admin",
            component: () =>
                import("./views/app/admin"),
            redirect: `${adminRoot}/admin`,
            meta: { roles: [UserRole.SUPERADMIN] },
            children: [{
                path: "/",
                name: "admin",
                component: () =>
                    import("./views/app/admin/list")
            },
            {
                path: "store",
                component: () =>
                    import("./views/app/admin/store")
            },
            {
                path: ":id/edit",
                component: () =>
                    import("./views/app/admin/edit")
            }
            ]
        },

        {
            path: "politicas",
            component: () =>
                import("./views/app/politicas"),
            redirect: `${adminRoot}/politicas`,
            meta: { roles: [UserRole.SUPERADMIN, UserRole.ADMIN] },
            children: [{
                path: "/",
                name: "politicas",
                component: () =>
                    import("./views/app/politicas/list")
            },
            {
                path: "terminos",
                component: () =>
                    import("./views/app/politicas/terminos/list")
            },
            {
                path: "datos",
                name: "datos",
                component: () =>
                    import("./views/app/politicas/datos/list")
            },
            {
                path: "condiciones",
                name: 'condiciones',
                component: () =>
                    import("./views/app/politicas/condiciones/list")
            },
            {
                path: "condiciones/store",
                component: () =>
                    import("./views/app/politicas/condiciones/store")
            },
            {
                path: "condiciones/:id/edit",
                component: () =>
                    import("./views/app/politicas/condiciones/edit")
            }
            ]
        },

        /*{
            path: "reports",
            component: () =>
                import ("./views/app/reports"),
            redirect: `${adminRoot}/reports/general`,
            meta: { roles: [UserRole.ADMIN] },
            children: [{
                    path: 'general',
                    component: () =>
                        import ("./views/app/reports/general")
                },
                {
                  path: 'capacitaciones',
                  component: () => import("./views/app/reports/capacitaciones")
                }
            ]
        }*/

        {
            path: "comunicaciones",
            component: () =>
                import("./views/app/comunicaciones"),
            redirect: `${adminRoot}/comunicaciones`,
            meta: { roles: [UserRole.SUPERADMIN, UserRole.ADMIN] },
            children: [{
                path: "/",
                name: "politicas",
                component: () =>
                    import("./views/app/politicas/list")
            },
                /* {
                    path: "terminos",
                    component: () =>
                        import("./views/app/politicas/terminos/list")
                }, */

            ]
        },

        {
            path: "publicidad",
            component: () => import("./views/app/publicidad"),
            redirect: `${adminRoot}/publicidad`,
            meta: { roles: [UserRole.SUPERADMIN, UserRole.ADMIN] },
            children: [
                {
                    path: "/",
                    name: "publicidad",
                    component: () => import("./views/app/publicidad/list"),
                },
                {
                    path: "store",
                    component: () => import("./views/app/publicidad/store"),
                },
                {
                    path: ":id/edit",
                    name: "publicidadedit",
                    component: () => import("./views/app/publicidad/edit"),
                },
            ],
        },
    ]
},
{
    path: "/user",
    component: () =>
        import("./views/user"),
    redirect: "/user/login",
    children: [{
        path: "login",
        component: () =>
            import("./views/user/Login")
    }]
},
{
    path: "*",
    component: () =>
        import("./views/Error")
}
];

const router = new VueRouter({
    linkActiveClass: "active",
    base: process.env.VUE_APP_BASE,
    routes,
    mode: "history"
});

router.beforeEach(AuthGuard);
export default router;